import * as React from "react";
import {GatsbyImage} from "gatsby-plugin-image";
import {Link, Trans, useI18next} from "gatsby-plugin-react-i18next";
import {FaFacebookF} from "@react-icons/all-files/fa/FaFacebookF";
import {FaTwitter} from "@react-icons/all-files/fa/FaTwitter";
import {graphql, useStaticQuery} from "gatsby";
import {DateTime} from "luxon";
import {FaGithub} from "@react-icons/all-files/fa/FaGithub";

const Footer: React.FC = () => {
	const {language} = useI18next();
	const {footer, logo, social} = useStaticQuery(
		graphql`
			query {
				logo: file(relativePath: {eq: "logo.png"}) {
					childImageSharp {
						gatsbyImageData(layout: FIXED, height: 50)
					}
				}
				footer {
					dataProtectionUrls {
						de
						en
					}
					imprintUrls {
						de
						en
					}
					links {
						title
						url
						locale
					}
				}
				social {
					company
					facebookUrl
					githubUrl
					twitterUrl
				}
			}
		`
	);

	return (
		<div className="w-full bg-white">
			<div className="max-w-6xl mx-auto px-6 py-10 md:pt-20 md:pb-10">
				<div className="block md:hidden  h-14">
					<Link to="/">
						<GatsbyImage
							alt="Logo"
							image={logo.childImageSharp.gatsbyImageData}
							className="w-36 mb-6"
						/>
					</Link>
				</div>
				<div className="flex justify-between">
					<div>
						<ul className="flex flex-col md:flex-row self-center justify-between">
							<li className="pb-2">
								<Link to="/contact-us"
											className="text-blakish hover:text-blueish transition-all text-base font-normal px-2.5">
									<Trans>Contact us</Trans>
								</Link>
							</li>
							{footer.links && footer.links.map((link, idx) => {
								if (link.locale && link.locale !== language) {
									return null;
								}

								return (
									<li className="pb-2" key={idx}>
										<a
											href={link.url}
											className="text-blakish hover:text-blueish transition-all text-base font-normal px-2.5"
											target="_blank"
										>
											{link.title}
										</a>
									</li>
								);
							})}
						</ul>
					</div>
					<div className="hidden md:block">
						<div className="flex justify-center h-14">
							<Link to="/">
								<GatsbyImage
									alt="Logo"
									image={logo.childImageSharp.gatsbyImageData}
									className="w-40 mb-6"
								/>
							</Link>
						</div>
						<p className="text-xs text-blakish">
							<span className="text-xs text-blueish">
								{social.company}
							</span> ©
							{' '}
							{DateTime.now().toFormat('yyyy')} .All Rights Reserved
						</p>
					</div>
					<div>
						<ul className="flex md:flex-row flex-col self-center justify-between">
							<li className="pb-2">
								<a
									href={footer.imprintUrls[language]}
									className="text-blakish hover:text-blueish transition-all text-base font-normal px-2.5"
								>
									<Trans>Imprint</Trans>
								</a>
							</li>
							<li className="pb-2">
								<a
									href={footer.dataProtectionUrls[language]}
									className="text-blakish hover:text-blueish transition-all text-base font-normal px-2.5"
								>
									<Trans>Data Protection</Trans>
								</a>
							</li>
						</ul>
					</div>
				</div>
				<p className="text-xs block md:hidden text-center pt-10 text-blakish">
					<span className="text-xs text-blueish">
						{social.company}
					</span> ©
					{' '}
					{DateTime.now().toFormat('yyyy')}. All Rights Reserved
				</p>
				<div className="flex justify-center pt-6">
					{social.facebookUrl &&
					<span className="rounded-full bg-greish w-10 h-10 mx-1 cursor-pointer">
            <span className="flex justify-center items-center pt-2.5">
							<a href={social.facebookUrl} target="_blank">
								<FaFacebookF className="text-xl text-metalic"/>
							</a>
            </span>
          </span>
					}
					{social.twitterUrl &&
					<span className="rounded-full bg-greish w-10 h-10 mx-1 cursor-pointer">
            <span className="flex justify-center items-center  pt-2.5">
							<a href={social.twitterUrl} target="_blank">
                <FaTwitter className="text-xl text-metalic "/>
							</a>
            </span>
          </span>
					}
					{social.githubUrl &&
					<span className="rounded-full bg-greish w-10 h-10 mx-1 cursor-pointer">
            <span className="flex justify-center items-center  pt-2.5">
							<a href={social.githubUrl} target="_blank">
                <FaGithub className="text-xl text-metalic"/>
							</a>
            </span>
          </span>
					}
				</div>
			</div>
		</div>
	);
};

export default Footer;
